import TableInput from 'components/elements/table/table-input';
import useFlightScheduleTableList from 'legacy-modules/cro/hooks/use-flight-schedule-table-list';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import {
  FlightScheduleDetailFormType,
  FlightScheduleFormType,
} from './flight-schedule-form-type';

const name = 'flightSchedules' as const;

export default function FlightScheduleTable() {
  const { control, getValues, clearErrors } =
    useFormContext<FlightScheduleFormType>();

  const { fields, update } = useFieldArray({
    name,
    keyName: 'customId',
    control,
  });

  const columns = useFlightScheduleTableList('editable');

  const dispatch = React.useCallback(
    (action) => {
      const currentRowIndex = action.rowIndex;
      const details = getValues(name) as FlightScheduleDetailFormType[];
      const detail = details[currentRowIndex];
      const columnId = action.columnId as keyof FlightScheduleDetailFormType;
      // const extra = action.extra as Value;

      const otherVal: () => Partial<FlightScheduleDetailFormType> = () => {
        return {};
      };

      if (action.type === 'update_cell') {
        const row = {
          ...detail,
          [action.columnId]: action.value,
          ...otherVal(),
        };

        update(currentRowIndex, row);

        clearErrors(`${name}.${currentRowIndex}.${columnId}`);
      }
    },
    [clearErrors, getValues, update],
  );

  const height = 'calc(100dvh - 120px - 64px - 48px)';

  return (
    <TableInput
      data={fields}
      columns={columns}
      name={name}
      dispatch={dispatch}
      noAddRemoveRow
      uniqueRowKey="id"
      tableContainerStyle={{
        minHeight: height,
        maxHeight: height,
      }}
    />
  );
}
